import { divisionFormatTypeIds, eventGenderTypeIds } from './eventConstants';

export const genderValues = {
    M: eventGenderTypeIds.MALE,
    F: eventGenderTypeIds.FEMALE,
    Mixed: eventGenderTypeIds.MIXED,
};

export const playerTypeValues = {
    singles: divisionFormatTypeIds.SINGLES,
    doubles: divisionFormatTypeIds.DOUBLES,
};

export const EventDeskTabKeys = {
    NEXT_AVAILABLE: 'nextAvailable',
    DAY_PLANNER: 'dayPlanner',
    COURT_SCHEDULER: 'courtSchedulerTab',
    MANAGE_SCHEDULE: 'scheduleTab',
    DRAW_EDITOR: 'drawEditor',
    PLAYERS_TAB: 'playersTab',
    NOTIFICATIONS: 'notificationsTab',
    ACCOUNTS: 'accountsTab',
    CHECK_IN: 'checkInTab',
    PRINT_SPOOLER: 'printSpoolerTab',
};

export const ManageAccountRoleIDs = {
    1: 'Admin',
    2: 'Owner',
    3: 'Volunteer',
};
